export default {
  ASISA_WEB_GLOBAL: 'https://www.asisa.es'
}
